import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { ListScreen } from "../../screens/lists/ListScreen.tsx";
import { listSearch } from "../../screens/lists/search.ts";

/**
 * `/lists/$listId`: a list worked through together. The open row is `?row=<key>` (a row can be sent to a colleague,
 * and the back button closes it); what the table shows is `?show=` (new, mine, nobody's, a state, dropped out).
 */
export const Route = createFileRoute("/_app/lists/$listId")({
  validateSearch: listSearch,
  loader: ({ context, params }) =>
    context.queryClient.prefetchQuery(actions.queryOptions("lists.get", { listId: params.listId })),
  component: ListScreen,
});
